// extracted by mini-css-extract-plugin
export default {"container":"Securities_container__dzQOr","pageContent":"Securities_pageContent__SYZwv"};